/**
 * When a shopper checks a "Size" filter option, also apply the
 * "Availability: In stock" filter so sold-out variants in that size
 * are excluded from the results. Shopify's native collection filters
 * combine filter groups with AND logic, but a Size filter alone still
 * matches products where ANY variant has that size (in stock or not).
 * Adding "In stock" narrows it to variants that are actually available.
 */
(function () {
  function syncAvailability(form) {
    var groups = form.querySelectorAll('details');
    var availabilityGroup = null;
    var sizeGroup = null;

    groups.forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;
      var label = summary.textContent.trim().toLowerCase();
      if (label === 'availability') availabilityGroup = details;
      if (label === 'size') sizeGroup = details;
    });

    if (!availabilityGroup || !sizeGroup) return;

    var checkboxes = availabilityGroup.querySelectorAll('input[type="checkbox"]');
    var inStockCheckbox = null;
    checkboxes.forEach(function (cb) {
      var label = cb.closest('label');
      if (label && /in stock/i.test(label.textContent)) {
        inStockCheckbox = cb;
      }
    });

    if (!inStockCheckbox) return;

    sizeGroup.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (cb.checked && !inStockCheckbox.checked) {
          inStockCheckbox.checked = true;
          inStockCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  document.querySelectorAll('#FacetFiltersFormMobile, form[id^="FacetFiltersForm"]').forEach(syncAvailability);
})();
